import React , {useEffect,useState} from "react";
import { useParams } from 'react-router-dom';
import ActivityEdit from "./sublist/activityedit";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"

export default function InstructorStudentActivityEdit() {

  let { slug,status,id } = useParams();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);

  return (
    <>     
    {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Activity"} /> }
     {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Activity"} /> }
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">         
          <ActivityEdit slug={slug} status={status} Id={id}/>
        </div>
      </div>
    </>
  );
}
